<template>
  <div id="app">
    <Header></Header>

    <Page no-image>
      <div class="pb-8 px-content">
        <div class="flex justify-center">
          <h1 class="headline">Produkte</h1>
        </div>

        <div class="flex flex-wrap mt-8">
          <a
            href="/produkte/innentreppen.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/innentreppen/1.jpg"
                  alt="Innentreppen"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Innentreppen</h2>
          </a>

          <a
            href="/produkte/aussentreppen.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/aussentreppen/1.jpg"
                  alt="Außentreppen"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Außentreppen</h2>
          </a>

          <a
            href="/produkte/innentreppengelaender.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/innentreppengelaender/1.jpg"
                  alt="Innentreppengeländer"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Innentreppengeländer</h2>
          </a>

          <a
            href="/produkte/balkongelaender.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/balkongelaender/1.jpg"
                  alt="Balkongeländer"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Balkongeländer</h2>
          </a>

          <a
            href="/produkte/balkone.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/balkone/1.jpg"
                  alt="Balkone"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Balkone</h2>
          </a>

          <a
            href="/produkte/carports.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/carports/1.jpg"
                  alt="Carports"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Carports</h2>
          </a>

          <a
            href="/produkte/fenstergitter.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/fenstergitter/1.jpg"
                  alt="Fenstergitter"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Fenstergitter</h2>
          </a>

          <a
            href="/produkte/ueberdachungen.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/ueberdachungen/1.jpg"
                  alt="Überdachungen"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Überdachungen</h2>
          </a>

          <a
            href="/produkte/handlaeufe.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/handlaeufe/5.jpg"
                  alt="Handläufe"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Handläufe</h2>
          </a>

          <a
            href="/produkte/tore.html"
            class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1 no-underline"
          >
            <div class="px-2 py-2 bg-white hover:shadow">
              <div class="relative pb-full">
                <Picture
                  imgClass="absolute object-cover w-full h-full"
                  src="img/produkte/tore/1.jpg"
                  alt="Tore"
                />
              </div>
            </div>
            <h2 class="text-center mt-1">Tore</h2>
          </a>
        </div>
      </div>

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Page from "../components/Page.vue";
import Picture from "../components/Picture.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    Picture,
  },
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>
